import { TypeListitem } from './typelistitem';
import { StudentDetail } from './StudentDetail';

export class SaveStudentDetails {

    public studentDetail: StudentDetail = new StudentDetail();
    status: string;
    public hashData: string;
    public selectedFamiliar: Array<TypeListitem> = new Array<TypeListitem>();

}
